export default {
  logout: 'Вы вышли из приложения',
  login: 'Вы вошли',
  authRequired: 'Необходима авторизация'
}
